<template>
    <div class="word-search__btn">
        <h5 class="title02">초성검색</h5>
        <ul class="word-search__list">
            <!-- 선택시 : active -->
            <li class="word-search__item" v-for="item in list" :class="consonant == item.cho ? 'active' : ''">
                <button type="button" class="btn" @click="emitConsonant(item.cho)">{{item.cho == 'AZ' ? 'A-Z' : item.cho}}</button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        list: []
    },
    data() {
        return {
            consonant: 'ㄱ',
        }
    },
    methods: {
        emitConsonant(consonant){
            this.consonant = consonant
            this.$emit('consonant', consonant)
        },
    }
}
</script>